'use strict';

import $ from 'jquery';

export default class Header {
  constructor() {
    $('.hamburger').on('click', () => {
      $('body').addClass('menu-open');
    });
    $('.exit-off-canvas').on('click', (e) => {
      e.preventDefault();
      $('body').removeClass('menu-open');
    });

    $('.has-dropdown > a').on('click', (e) => {
      if ($(window).width() < 1001) {
        e.preventDefault();
        let $sub = $(e.currentTarget).parent().find('ul');
        if ($sub.hasClass('is-opened')) {
          this._closeSubmenu($sub);
        } else {
          this._openSubmenu($sub);
        }
      } else {
        if ($('html').hasClass('touch')) {
          let $this = $(this);
          e.preventDefault();
          // $('.main-nav').find('li.hover').removeClass('hover');
          // $this.parent().addClass('hover');
          /*setTimeout(() => {
            $this.parent().removeClass('hover');
          }, 1500);*/
        }
      }
    });

  }

  _openSubmenu($el) {
    $el.addClass('is-opened');
    let childNr = $el.find('li').length;
    let childHeight = $el.find('li:first-child').outerHeight();
    $el.css({'max-height' : (childNr * childHeight) + 'px'});
  }

  _closeSubmenu($el) {
    $el.removeClass('is-opened');
    $el.css({'max-height' : 0});
  }
}
